<template>
    <div>
        <div class="container">
            <div class="row mt-5">
                <div class="col-12 text-center my-5">
                    <h3 class="heading">Testimonials</h3>
                    <hr class="custom-hr">
                </div>
            </div>
            <div class="row">
                <div class="col-12 my-5">
                    <carousel v-bind="testimonialOptions" >
                        <div v-for="testimonial in testimonials" :key="testimonial.name" class="testimonial d-flex align-items-center justify-content-center">                            
                            <div class="row testimonial-border">
                                <div class="col-12">
                                    <div class="testimonial-text text-center my-5 pt-5">
                                        <p class="testimonial-text"> <q>{{ testimonial.text }}</q></p>
                                        <div class="testimonial-name mt-5"><b> {{ testimonial.name }} </b></div>
                                    </div>
                                </div>
                                <div class="testimonial-shape">
                                    <img class="testimonial-image p-2" :src="testimonial.image">  
                                </div>
                            </div>                            
                        </div>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import carousel from 'vue-owl-carousel'
export default {
    components:{
        carousel
    },
    data(){
        return{
            testimonials:[
                {image: require("../assets/images/testimonials/telegraph.jpg"), name:'The Telegraph', text:'World-class documentaries and short films, film personalities and attractive cultural events...highlights of the Urban Winter Festival-13'},
                {image: require("../assets/images/testimonials/eclectic.jpg"), name:'The Eclectic Northeast', text:'THE Metropolis Urban Winter Festival, 2104 was a big hit amongst people of all ages and surely the next edition will be bigger and better like always.'},
                {image: require("../assets/images/testimonials/test.jpg"), name:'guwahationline.in', text:'January is the time of the year when the people of Guwahati roars.."ALOHA METROPOLIS"!! Metropolis is one of the major Art & Cultural Festivals held in Guwahati'},
                {image: require("../assets/images/testimonials/xbhp.jpg"), name:'XBhp', text:'It\'s the biggest festival in Guwahati'}
            ],
            testimonialOptions:{
                nav: false,
                autoplay: true,
                smartSpeed: 600,
                items: 1,
                margin:10,
                autoHeight: true,
                responsive:{
                    0:{
                        items:1,
                        nav:false
                    },
                    400:{
                        items:1,
                        nav:false
                    },
                    800:{
                        items:1,
                        nav:false
                    },

                }
            }
        }
    }
}
</script>


<style scoped>
.testimonial{
    width: 98%;
    position: relative;
    height: 20rem;
    position: relative;
    border: 2px solid #e1e1e1;
    background-color: #fff;
    padding: 1rem;
    margin-bottom: .7rem;
    margin-top: 5rem;
    border-radius: 20px
   
}

.main-testimonial{
    height: 100%;
}

.testimonial-shape{
    position: absolute;
    top: 1%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 10rem;
    height: 10rem;
    box-shadow: 1px 1px 7px -1px rgba(0,0,0,0.42);
    border-radius: 50%;
    overflow: hidden;
    background-color: #fff;
}

.testimonial-shape img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.testimonial-image{
    height: 100%;
    width: 100%;
    padding: .2rem;
}

.testimonial-text{
    font-size: 1.8rem;
    /* font-family: Bad Script; */
    display: block;
}

@media (max-width: 700px){
    .testimonial-shape{
        top: -.3rem;
        width: 6rem;
        height: 6rem;
    }
    .testimonial-text{
    font-size: 1.5rem;
    
}
}
</style>
